var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.83325C10.4602 5.83325 10.8333 6.20635 10.8333 6.66659V11.8088C11.8043 12.152 12.5 13.0781 12.5 14.1666C12.5 15.5473 11.3807 16.6666 10 16.6666C8.61925 16.6666 7.5 15.5473 7.5 14.1666C7.5 13.0781 8.19566 12.152 9.16667 11.8088V6.66659C9.16667 6.20635 9.53975 5.83325 10 5.83325Z",
    fill: "#31B064"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 2.29175C8.96466 2.29175 8.12516 3.13121 8.12516 4.16675V10.8331C8.12516 11.0297 8.0327 11.2147 7.87553 11.3328C7.01388 11.9801 6.4585 13.0084 6.4585 14.1667C6.4585 16.1227 8.04415 17.7084 10.0002 17.7084C11.9562 17.7084 13.5418 16.1227 13.5418 14.1667C13.5418 13.0086 12.9864 11.9804 12.1247 11.3332C11.9677 11.2151 11.8752 11.03 11.8752 10.8334V4.16675C11.8752 3.13121 11.0357 2.29175 10.0002 2.29175ZM6.87516 4.16675C6.87516 2.44086 8.27427 1.04175 10.0002 1.04175C11.7261 1.04175 13.1252 2.44086 13.1252 4.16675V10.5346C14.1447 11.4124 14.7918 12.714 14.7918 14.1667C14.7918 16.8131 12.6465 18.9584 10.0002 18.9584C7.3538 18.9584 5.2085 16.8131 5.2085 14.1667C5.2085 12.714 5.85559 11.4122 6.87516 10.5342V4.16675Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp);
export default __webpack_public_path__ + "static/media/temp.a6903343d727420e4256662f6e334a74.svg";
export { ForwardRef as ReactComponent };